import { useState } from "react";
import { useSocket } from "../config/socketContext";


const Chat = () => {
  const { messages, sendMessage, sendTypingStatus, typingStatus } = useSocket();
  const [message, setMessage] = useState("");
  const user = "User1"; // You can replace this with actual user info

  // Handle message input change
  const handleInputChange = (e) => {
    setMessage(e.target.value);
    sendTypingStatus(user); // Notify others that this user is typing
  };

  // Handle send message
  const handleSendMessage = () => {
    if (message.trim()) {
      sendMessage({ user, text: message, timestamp: new Date() });
      setMessage(""); // Clear input field
    }
  };

  return (
    <div className="bg-[#fffdfc] relative h-full w-full">
      {/* <h2>Chat Room</h2> */}



      <div className="overflow-y-auto hide-scrollbar h-[85%] p-5">
        {message ? (
          messages && messages.map((msg, index) => (
            <p key={index}>
              <strong>{msg.user}:</strong> {msg.text}{" "}
              <small>({new Date(msg.timestamp).toLocaleTimeString()})</small>
            </p>
          ))
        ) : (
          <div
            role="status"
            className="p-4 space-y-4 border-gray-200 divide-y divide-gray-200 rounded-sm shadow-sm animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700"
          >
            {[...Array(10)].map((_, i) => (
              <div key={i} className="flex items-center justify-between pt-4">
                <div>
                  <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                  <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
              </div>
            ))}
          </div>
        )}

      </div>
      {/* {typingStatus && <p style={{ fontStyle: "italic", color: "gray" }}>{typingStatus}</p>} */}
      <div className="absolute flex items-center bottom-0  border-[#d8c9ae] h-[15%] w-full p-4 gap-4">
        <input type="text" value={message} onChange={handleInputChange} placeholder="Type a message..." className="py-2 px-4 border border-[#575757] w-full outline-none" />
        <button onClick={handleSendMessage} className="px-4 py-2 bg-[#575757] hover:bg-[#393939] text-[#d8c9ae]">Send</button>
      </div>
    </div>
  );
};

export default Chat;
